import { FC } from 'react';
import Typography from '@ixigo/iui/Typography';
import { CallHistoryItem } from '../timelineTypes';
import ContentSection from '../ContentSection';
import BaseDetailsModal from './BaseDetailsModal';

interface CallHistoryDetailsProps {
    call: CallHistoryItem | null;
    isOpen: boolean;
    onClose: () => void;
}

const CallHistoryDetails: FC<CallHistoryDetailsProps> = ({ call, isOpen, onClose }) => {
    if (!call) return null;

    return (
        <BaseDetailsModal isOpen={isOpen} onClose={onClose} title={call.heading}>
            <ContentSection title='Call Summary'>
                <Typography variant='body-md' className='text-charcoal-800 leading-relaxed'>
                    {call.summary}
                </Typography>
            </ContentSection>
        </BaseDetailsModal>
    );
};

export default CallHistoryDetails;
